import React, { useEffect, useState } from "react";
import { Container, Row, Col, CardBody, Card, Table, Badge, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import axios from "axios";

import {get} from "../../helpers/api_helper";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const Dashboard = () => {
  document.title = "Dashboard | PagaSunt Admin";

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    pendingListings: [],
    latestListings: [],
    latestUsers: [],
    counts: { pending_count: 0 }
  });

  // Fetch data from API
const fetchDashboardData = async () => {
  try {
    // Nu mai e nevoie de URL-ul complet sau headers, helper-ul se ocupă de tot
    const response = await get("/admin/dashboard-stats");
    
    // Deoarece în helper am pus .then(res => res.data), response este deja obiectul tau
    if (response.status === "success") {
      setData(response.data);
    }
  } catch (error) {
    console.error("Eroare dashboard:", error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('ro-RO', options);
  };

  if (loading) {
    return (
      <div className="page-content text-center">
        <Spinner color="primary" />
        <p className="mt-2">Se încarcă datele...</p>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="PagaSunt" breadcrumbItem="Panou de Control" />

          <Row>
            {/* Secțiune: Anunțuri spre Aprobare */}
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <h4 className="card-title mb-0">Anunțuri în așteptare (Pending)</h4>
                    <Badge color="soft-danger" className="font-size-12">
                      {data.counts.pending_count} Anunțuri Noi
                    </Badge>
                  </div>
                  <div className="table-responsive">
                    <Table className="table-centered table-nowrap mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Imagine</th>
                          <th>Titlu Anunț</th>
                          <th>Utilizator</th>
                          <th>Preț</th>
                          <th>Data</th>
                          <th>Acțiuni</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.pendingListings.length > 0 ? (
                          data.pendingListings.map((listing) => (
                            <tr key={listing.id}>
                              <td>
                                {listing.main_image_url ? (
                                  <img src={listing.main_image_url} alt="img" className="avatar-sm rounded bg-light" style={{ objectFit: 'cover' }} />
                                ) : (
                                  <div className="avatar-sm bg-light rounded d-flex align-items-center justify-content-center text-muted">Fără foto</div>
                                )}
                              </td>
                              <td>
                                <strong>{listing.title}</strong> <br />
                                <small>{listing.category?.name || "Fără categorie"}</small>
                              </td>
                              <td>{listing.user?.name || "N/A"}</td>
                              <td>{listing.price} {listing.currency}</td>
                              <td>{formatDate(listing.created_at)}</td>
                              <td>
                                <Link 
    to={`/edit-anunt/${listing.id}`} 
    className="btn btn-sm btn-soft-primary me-2"
    title="Editează Anunț"
  >
    <i className="uil uil-pen font-size-14"></i>
  </Link>
  
                                <button className="btn btn-sm btn-success me-2">Aprobă</button>
                                <button className="btn btn-sm btn-danger">Refuză</button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center text-muted">Nu există anunțuri în așteptare.</td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            {/* Secțiune: Ultimele Anunțuri (Aprobate) */}
<Col xl={6}>
  <Card>
    <CardBody>
      <h4 className="card-title mb-4">Ultimele Anunțuri Active</h4>
      <div className="table-responsive">
        <Table className="table-borderless table-centered table-nowrap mb-0">
          <tbody>
            {data.latestListings.map((listing) => (
              <tr key={listing.id}>
                <td style={{ width: "60px" }}>
                  {/* Înlocuim avatar-xs cu o imagine reală */}
                  {listing.main_image_url ? (
                    <img 
                      src={listing.main_image_url} 
                      alt="img" 
                      className="avatar-xs rounded-circle bg-light" 
                      style={{ objectFit: 'cover' }} 
                    />
                  ) : (
                    <div className="avatar-xs bg-soft-primary text-primary rounded-circle text-center p-1 font-weight-bold">
                      {listing.title.charAt(0).toUpperCase()}
                    </div>
                  )}
                </td>
                <td>
                  <h5 className="font-size-14 mb-1 text-truncate" style={{ maxWidth: "200px" }}>
                    {listing.title}
                  </h5>
                  <p className="text-muted mb-0">{listing.location}</p>
                </td>
                <td className="text-end">
                  <h5 className="font-size-14 mb-0">
                    {listing.price} {listing.currency}
                  </h5>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <div className="mt-4 text-center">
        <Link to="/anunturi" className="btn btn-primary btn-sm">Vezi toate anunțurile</Link>
      </div>
    </CardBody>
  </Card>
</Col>

            {/* Secțiune: Utilizatori Recenți */}
     <Col xl={6}>
  <Card>
    <CardBody>
      <h4 className="card-title mb-4">Utilizatori Recenți</h4>
      <div className="table-responsive">
        <Table className="table-borderless table-centered table-nowrap mb-0">
          <tbody>
            {data.latestUsers.map((user) => (
              <tr key={user.id}>
                <td style={{ width: "60px" }}>
                  <div className="avatar-xs bg-soft-info text-info rounded-circle text-center p-1 font-weight-bold">
                    {/* Folosim prima literă din nume SAU 'U' de la Utilizator dacă numele e null */}
                    {user.name ? user.name.charAt(0).toUpperCase() : (user.phone ? user.phone.charAt(0) : "U")}
                  </div>
                </td>
                <td>
                  <h5 className="font-size-14 mb-1">
                    {user.name || "Utilizator PagaSunt"}
                  </h5>
                  <p className="text-muted mb-0">
                    {user.email || user.phone || "Fără contact"}
                  </p>
                </td>
                <td className="text-end">
                  <Badge color="soft-success" className="rounded-pill">
                    {user.role === 'admin' ? 'Admin' : 'Activ'}
                  </Badge>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <div className="mt-4 text-center">
        <Link to="/utilizatori" className="btn btn-outline-secondary btn-sm">
          Gestionează Utilizatori
        </Link>
      </div>
    </CardBody>
  </Card>
</Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;